import { Healthcareservice } from 'app/core/interfaces/healthcareservice';

export interface SchedulePaymentSummary {
  privatePriceLabel: string;
  coverageLabel: string;
  compactLabel: string;
  privatePrice: number | null;
}

type PricedService = Pick<Healthcareservice, 'price_low' | 'price_high'>;

const COVERAGE_LABEL = 'Convênios: consulte cobertura e valor';

export function summarizeSchedulePayment(services: readonly PricedService[] = []): SchedulePaymentSummary {
  const prices = services
    .map((service) => parsePrice(service.price_low) ?? parsePrice(service.price_high))
    .filter((price): price is number => price !== null);
  const privatePrice = prices.length ? Math.min(...prices) : null;
  const privatePriceLabel = privatePrice === null
    ? 'Particular: valor sob consulta'
    : `Particular desde ${formatPrice(privatePrice)}`;

  return {
    privatePrice,
    privatePriceLabel,
    coverageLabel: COVERAGE_LABEL,
    compactLabel: `${privatePriceLabel} · ${COVERAGE_LABEL}`,
  };
}

export function formatSchedulePrice(value: number): string {
  return formatPrice(value);
}

function parsePrice(value: string | number | null | undefined): number | null {
  if (typeof value === 'number') {
    return Number.isFinite(value) && value > 0 ? value : null;
  }

  const raw = String(value ?? '').trim().replace(/[R$\s]/g, '');
  if (!raw) return null;

  const normalized = raw.includes(',')
    ? raw.includes('.')
      ? raw.replace(/\./g, '').replace(',', '.')
      : raw.replace(',', '.')
    : raw;
  const price = Number(normalized);

  return Number.isFinite(price) && price > 0 ? price : null;
}

function formatPrice(value: number): string {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}
